export default theme => ({
  blockContainer: {
    position: 'relative',
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      height: 'initial',
      // minHeight: '100%',
      width: '100%',
      minWidth: 'initial',
      padding: 0,
      backgroundColor: theme.palette.grey.light,
    },
  },
  background: {
    position: 'absolute',
    zIndex: 1,
    height: '100%',
    width: '100vw',
    minWidth: '1400px',
    backgroundColor: theme.palette.grey.light,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  bgImg: {
    position: 'absolute',
    height: '100%',
    width: '40%',
    right: 0,
    background: `no-repeat url(${theme.url('/blocks/b22-bg.jpg')})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  greenCurve: {
    position: 'absolute',
    bottom: -5,
    right: '25%',
    height: '50%',
    width: '45%',
    background: `no-repeat url(${theme.url('/blocks/b22-green-curve.svg')})`,
    backgroundSize: 'contain',
    backgroundPosition: 'right bottom',
  },
  content: {
    zIndex: 5,
    position: 'relative',
    width: '60%',
    height: '100%',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      width: '100%',
      minWidth: 'initial',
      height: 'initial',
      right: 'initial',
      paddingBottom: theme.spacing(2),
    },
  },
  articles: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    [theme.breakpoints.down('md')]: {
      display: 'block',
      position: 'relative',
      width: 'initial',
      height: 'initial',
      paddingTop: theme.spacing(2),
    },
  },
  article: {
    padding: theme.spacing(6),
    maxWidth: '80%',
    '&:first-child': {
      paddingBottom: 0,
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: 'initial',
      paddingBottom: 0,
    },
  },
});
